import "./assets/main.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@vueup/vue-quill/dist/vue-quill.bubble.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./assets/css/remixicon.css";
import "./assets/css/sidebar-menu.css";
import "./assets/css/simplebar.css";
import "./assets/scss/style.css";

import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import axios from "axios";
import store from "./Store/index";
import { createVuetify } from "vuetify";

// import { getImage } from './utils/imageUtils';

import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { VDrilldownTable } from "@wdns/vuetify-drilldown-table";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import print from "vue3-print-nb";

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi", // Specifies Material Design Icons as the default
  },
  theme: {
    themes: {
      light: {
        primary: "#1976D2",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
      dark: {
        primary: "#1E88E5",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
    dark: true, // Set to true to enable dark mode
  },
});

import router from "@/router/index.ts";

const app = createApp(App);

app.config.globalProperties.$isDarkTheme = () =>
  document.body.classList.contains("dark-theme");

app.component("VDrilldownTable", VDrilldownTable);
app.use(vuetify);
app.use(router);
app.use(store);
app.use(createPinia());
app.use(VueSweetalert2);
app.mount("#app");
app.use(print);

// Make it available globally as $getImage
// app.config.globalProperties.$getImage = getImage;
